import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { sendToGoogleAnalytics } from '../../../../core/utilities';
import { Store } from '@ngrx/store';
import * as locationListSelectors from '../../location-list/state/location-list-selectors';
import * as ccListSelectors from '../state/cc-list-selectors';
import { CCActionBarActions } from '../state/cc-list-actions';
import { FormatDistancePipe } from '../../../../pipes/format-distance.pipe';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-cc-radius',
    templateUrl: './cc-radius.component.html',
    styleUrls: ['../gmb-location-grp/cc-gmb-location-grp.component.scss',
                './cc-radius.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatFormField,
        MatSelect,
        FormsModule,
        ReactiveFormsModule,
        MatOption,
        FormatDistancePipe,
    ],
})
export class CcRadiusComponent implements OnInit, OnDestroy {

  radius: {formControl: FormControl<number|null>, radiusValues: number[]} = {
    formControl: new FormControl(null),
    radiusValues: [50, 100, 200, 500, 1000, 2000, 5000, 10000],
  };
  focusedLocation$ = this.store.select(locationListSelectors.selectFocusedLocation);

  private componentDestroyed = new Subject<void>();

  constructor(
      private store: Store,
  ) {
  }

  ngOnInit(): void {
    this.initRadius();
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
  }

  /**
   * Fetches the claim-and-clean search radius saved on account-level and initializes this.radius
   * with it.
   * Initiates a formControl value change listener
   */
  private initRadius() {
    this.focusedLocation$
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((v) => !!v ?
            this.radius.formControl.enable({ emitEvent: false }) :
            this.radius.formControl.disable({ emitEvent: false }),
        );

    // init formField value changes listener
    this.radius.formControl.valueChanges
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((newValue: number) => {
          this.updateRadius(newValue);
        });

    // listen to radius value changes and set local form group
    this.store.select(ccListSelectors.selectCcRadius)
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((res) => {
          // set new radius formField value, but do not trigger valueChanges event
          this.radius.formControl.setValue(res, { emitEvent: false });
        });
  }

  /**
   * Updates cc search radius on the BE.
   * @param newValue Search radius setting
   */
  private updateRadius(newValue: number) {
    sendToGoogleAnalytics('C&C actions',
        'Set radius');
    this.store.dispatch(CCActionBarActions.updateCCRadius({ ccSearchRadius: newValue }));
  }

}
